import React, { useEffect } from "react";
import { loadStyles } from "../../../utils/cssLoader";
import { buildAdSize } from "../../../utils/interactivesHelper";

/**
 * Ad banner widget with configurable size ratio.
 * Supports image ads (via src URL) and iframe embeds.
 *
 * Props:
 *  ratio     - Size string e.g. "300x250", "728x90", "160x600"  (default: "300x250")
 *  src       - Ad image URL or iframe embed URL
 *  link      - Click-through URL (wraps image ads in <a>)
 *  alt       - Alt text for image ads
 *  loadCSS   - Whether to load interactivesAd styles
 */
const AdWidget = ({
  ratio = "300x250",
  src = "",
  link = "",
  alt = "Advertisement",
  loadCSS = true,
}) => {
  const { width, height } = buildAdSize(ratio);
  const isIframe = src.includes("iframe") || src.endsWith(".html") || src.includes("doubleclick") || src.includes("googlesyndication");

  useEffect(() => {
    if (loadCSS === true || loadCSS === "true") {
      loadStyles("interactivesAd");
    }
  }, [loadCSS]);

  const containerStyle = {
    width: `${width}px`,
    height: `${height}px`,
    maxWidth: "100%",
    overflow: "hidden",
  };

  const renderContent = () => {
    if (!src) {
      return (
        <div
          className="interactives-ad__placeholder"
          style={{ width: "100%", height: "100%" }}
        />
      );
    }

    if (isIframe) {
      return (
        <iframe
          src={src}
          width={width}
          height={height}
          frameBorder="0"
          scrolling="no"
          title={alt}
          className="interactives-ad__iframe"
        />
      );
    }

    const img = (
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        className="interactives-ad__image"
        loading="lazy"
      />
    );

    return link ? (
      <a href={link} target="_blank" rel="noopener noreferrer" className="interactives-ad__link">
        {img}
      </a>
    ) : img;
  };

  return (
    <div className="interactives-ad" style={containerStyle} data-ratio={ratio}>
      {renderContent()}
    </div>
  );
};

export default AdWidget;
